// theme coloring definition

const themes = {
  light: {
    rainbow: {
      palette: {
        brand: '#003e39',
        mainBackground: '#97a3b4',
        success: '#208e75',
        secondary: '#001715',
      },
    },
  },
  dark: {
    rainbow: {
      palette: {
        brand: '#f6ad55',
        mainBackground: '#333c4c',
        success: '#aa8109',
        secondary: '#aa4109',
      },
    },
  },
}

export default themes
